import React, { useState } from "react"
import { Box, Flex, Grid, Heading, Text } from "@theme-ui/components"
import { getArticlePath } from "../utils/path"
import { GatsbyImage } from "gatsby-plugin-image"
import { InboundLink } from "./link"
import AccordionClosed from "../images/accordion-closed.inline.svg"
import { render } from "datocms-structured-text-to-plain-text"

const ArticleThumb = ({ article, index, small }) => {
  const [hoverThumb, setHoverThumb] = useState(false)

  return (
    <Box
      sx={{
        overflow: "hidden",
        height: "100%",
      }}
      onMouseEnter={() => setHoverThumb(true)}
      onMouseLeave={() => setHoverThumb(false)}
    >
      <InboundLink
        to={getArticlePath(article, article.locale)}
        sx={{ textDecoration: "none", height: "100%", display: "block" }}
      >
        <Flex
          sx={{
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              ".gatsby-image-wrapper": {},
            }}
          >
            <Box
              sx={{
                display: ["none", "flex"],
                svg: {
                  maxWidth: ["28px", "39px"],
                  maxHeight: ["28px", "39px"],
                  width: "auto",
                  height: "24px",
                  fill: "primary",
                },
                py: [3, 4],
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  transform: hoverThumb && "rotate(45deg)",
                  transition: "all .2s ease",
                }}
              >
                <AccordionClosed />
              </Box>
            </Box>
            <GatsbyImage image={article.heroImage.gatsbyImageData} alt="" />
          </Box>
          <Box sx={{ mt: 3 }}>
            <Text
              sx={{
                color: "primary",
                fontSize: [1],
                letterSpacing: "-.5px",
                fontWeight: "400",
              }}
            >
              {article.meta.firstPublishedAt}
            </Text>
            <Heading
              as="h2"
              variant="h6"
              sx={{
                mb: 3,
                mt: 0,
                color: "text",
                fontWeight: "400",
                textTransform: "uppercase",
              }}
            >
              {article.title.length > 53
                ? article.title.substring(0, 53) + "..."
                : article.title}{" "}
            </Heading>
            <Text as="p" sx={{ fontSize: 1 }} mb={5}>
              {render(article.structuredBody)
                ? render(article.structuredBody).substring(0, 120) + " ..."
                : ""}
            </Text>
          </Box>
        </Flex>
      </InboundLink>
    </Box>
  )
}

export default ArticleThumb
